import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import TranslationsProvider from '@utils/i18n/i18n';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import Cookies from '@utils/Cookies/Cookies';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import store from '@App/app.store';
import translator from '@App/app.translator';
import routes from '@App/app.routes';
import theme from '@style/theme.json';
import AuthProvider from '@App/components/AuthProvider/AuthProvider';

import './app.css';

const router = createBrowserRouter(routes);

const queryClient = new QueryClient();

function App() {
  useEffect(() => document.documentElement.setAttribute('data-app-initialised', true), []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <StoreProvider store={store}>
          <ThemeProvider theme={theme}>
            <ErrorBoundary>
              <TranslationsProvider translator={translator}>
                <RouterProvider router={router} />
                <Cookies useConfig className="nazka-cookies" />
              </TranslationsProvider>
            </ErrorBoundary>
          </ThemeProvider>
          <WindowObserver />
        </StoreProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
